import React from "react";
import Tab from "../../common/Tab/Tab";
import TabItem from "../../common/Tab/TabItem";

const ReportTab = (props: any) => {
    return (
        <Tab tabId="identity-vault-tabs">
            <TabItem title="Agreeableness" link="/my-reputation/agreeableness" tabNo="1" selectedTab={props.selectedTab} />
            <TabItem title="Conscientiousness" link="/my-reputation/conscientiousness" tabNo="2" selectedTab={props.selectedTab} />
            <TabItem title="Emotional Range" link="/my-reputation/emotional-range" tabNo="3" selectedTab={props.selectedTab} />
            <TabItem title="Openness" link="/my-reputation/openness-to-experiences" tabNo="4" selectedTab={props.selectedTab} />
            <TabItem title="Extraversion" link="/my-reputation/extraversion" tabNo="5" selectedTab={props.selectedTab} />
        </Tab>
    );
};
export default ReportTab;
